import React from 'react';
import DropdownMenu from 'react-dd-menu';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';

import Link from '../../components/Link';
import menuData from '../../data/navigation';
import { breakpoints } from '../../constants';
import menuSeparatorHeader from '../assets/menu-separator.png';
import menuSeparator from '../assets/menu-separator-blue.png';

const Menu = styled.ul`
    list-style: none;
    display: flex;
    flex-direction: horizontal;

    & > li {
        position: relative;
        margin-right: 60px;
        cursor: pointer;
        color: #003056;
        border-bottom-width: 1px;
        border-bottom-style: solid;
        text-decoration: none;
        &:last-of-type {
            margin-right: 0;
        }
        &:after {
            content: '';
            display: block;
            cursor: auto;
            background: url(${menuSeparator}) no-repeat center;
            position: absolute;
            top: -5px;
            right: -40px;
            width: 19px;
            height: 38px;
        }
        &:last-of-type:after {
            display: none;
        }
    }
`;

const MenuHeader = styled(Menu)`
    li:after {
        background-image: url(${menuSeparatorHeader});
    }
    li,
    li > a {
        color: white;
    }

    @media (max-width: ${breakpoints.tablet}) {
        li,
        li > a {
            color: #003056;
        }
        li:after {
            background-image: url(${menuSeparator});
        }
    }
`;

const MenuItem = styled.li`
    .dd-menu-items {
        display: ${(props) => (props.isOpen ? 'inherit' : 'none')};
        position: absolute;
        z-index: 100;
        min-width: 250px;
        background-color: white;
        top: 2.5rem;
        padding: 10px 0;
        box-shadow: 1px 3px 7px #504c4c2e;
        background-color: #e0f5fd;
        li {
            padding: 7px 19px;
            width: 100%;
            & > a {
                text-decoration: none;
                border-bottom-width: 1px;
                border-bottom-style: solid;
                color: #003056;
            }
            &:hover {
                background-color: white;
                &,
                & > a {
                    color: #20bbef;
                    border: none;
                }
            }
        }
        &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 10px;
            width: 0;
            height: 0;
            border: 9px solid transparent;
            border-bottom-color: #e0f5fd;
            border-top: 0;
            margin-top: -9px;
        }
    }
`;

const MenuItemHeader = styled(MenuItem)`
    .dd-menu-items {
        background-color: white;
        li {
            &:hover {
                background-color: #e0f5fd;
            }
        }
        &:after {
            border-bottom-color: white;
        }
    }
`;

export class Navigation extends React.Component {
    state = {
        opened: '',
    };

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const {
            intl: { locale },
            header,
            className,
        } = this.props;
        const MenuComponent = header ? MenuHeader : Menu;

        return (
            <MenuComponent className={className}>
                {menuData[locale].map((item) => this.renderMenuItem(item))}
            </MenuComponent>
        );
    }

    renderMenuItem = (item) => {
        const {
            intl: { locale },
            header,
        } = this.props;
        const menuOptions = {
            isOpen: this.state.opened === item.title,
            close: this.close,
            toggle: <span onClick={this.toggle(item.title)}>{item.title}</span>,
            align: 'left',
        };
        const MenuItemComponent = header ? MenuItemHeader : MenuItem;

        return !!item.items ? (
            <MenuItemComponent key={item.title} isOpen={menuOptions.isOpen}>
                <DropdownMenu {...menuOptions}>
                    {item.items &&
                        item.items.map((i) => (
                            <li key={i.title}>
                                <Link to={i.link}>{i.title}</Link>
                            </li>
                        ))}
                </DropdownMenu>
            </MenuItemComponent>
        ) : (
            <li key={item.title}>
                <Link to={item.link} style={{ textDecoration: 'none' }}>
                    {item.title}
                </Link>
            </li>
        );
    };

    toggle = (item) => () => {
        this._isMounted &&
            this.setState({ opened: this.state.opened === item ? '' : item });
    };

    close = () => {
        this._isMounted && this.setState({ opened: '' });
    };
}

export default injectIntl(Navigation);



// WEBPACK FOOTER //
// ./src/layouts/components/Navigation.js